document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cartRoot = root.endsWith('/') ? root : `${root}/`;

  const mobileButton = document.querySelector('[data-mobile-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileButton && mobileNav) {
    mobileButton.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      mobileButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const product = select.closest('.product-info') || document;
      const price = product.querySelector('[data-product-price]');
      const compare = product.querySelector('[data-product-compare]');
      const submit = product.querySelector('[data-product-submit]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) compare.textContent = option.dataset.compare || '';
      if (submit) {
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? 'Add to cart' : 'Sold out';
      }
    });
  });

  const cartDrawer = document.querySelector('[data-bottom-cart]');
  const cartPanel = document.querySelector('[data-cart-panel]');
  const cartDockToggle = document.querySelector('[data-cart-dock-toggle]');
  const headerCartToggles = document.querySelectorAll('[data-cart-toggle]');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartStatus = document.querySelector('[data-cart-status]');
  let statusTimer;

  const formatMoney = (cents, currency) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'FJD',
        currencyDisplay: 'narrowSymbol'
      }).format((cents || 0) / 100);
    } catch (error) {
      return `$${((cents || 0) / 100).toFixed(2)}`;
    }
  };

  const setCartOpen = (open) => {
    if (!cartDrawer || !cartPanel) return;
    cartDrawer.dataset.cartOpen = open ? 'true' : 'false';
    cartPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (cartDockToggle) cartDockToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    headerCartToggles.forEach((button) => button.setAttribute('aria-expanded', open ? 'true' : 'false'));
  };

  const showStatus = (message) => {
    if (!cartStatus) return;
    cartStatus.textContent = message;
    cartStatus.classList.add('is-visible');
    window.clearTimeout(statusTimer);
    statusTimer = window.setTimeout(() => cartStatus.classList.remove('is-visible'), 2200);
  };

  if (cartDockToggle) {
    cartDockToggle.addEventListener('click', () => setCartOpen(cartDrawer.dataset.cartOpen !== 'true'));
  }
  headerCartToggles.forEach((button) => {
    button.addEventListener('click', (event) => {
      if (!cartDrawer) return;
      event.preventDefault();
      setCartOpen(cartDrawer.dataset.cartOpen !== 'true');
    });
  });
  if (cartClose) cartClose.addEventListener('click', () => setCartOpen(false));

  const renderCart = (cart) => {
    if (!cartDrawer) return;
    const itemCount = cart.item_count || 0;
    const itemLabel = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
    const currency = cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'FJD';

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = itemCount;
      el.classList.toggle('is-empty', itemCount === 0);
    });
    const panelCount = document.querySelector('[data-cart-panel-count]');
    const dockCount = document.querySelector('[data-cart-dock-count]');
    const dockTotal = document.querySelector('[data-cart-dock-total]');
    const subtotal = document.querySelector('[data-cart-subtotal]');
    const checkout = document.querySelector('[data-cart-checkout]');
    const mpaisaButtons = document.querySelectorAll('[data-mpaisa-checkout]');
    if (panelCount) panelCount.textContent = itemLabel;
    if (dockCount) dockCount.textContent = itemLabel;
    if (dockTotal) dockTotal.textContent = formatMoney(cart.total_price, currency);
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price, currency);
    if (checkout) checkout.disabled = itemCount === 0;
    mpaisaButtons.forEach((button) => { button.disabled = itemCount === 0; });

    const itemsContainer = document.querySelector('[data-cart-items]');
    if (!itemsContainer) return;
    if (!cart.items || cart.items.length === 0) {
      itemsContainer.innerHTML = '<div class="bottom-cart__empty">Your cart is empty.</div>';
      return;
    }

    itemsContainer.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${item.image}" alt="" loading="lazy">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="bottom-cart__variant">${escapeHtml(item.variant_title)}</div>` : '';
      const minusQty = Math.max(0, item.quantity - 1);
      return `
        <div class="bottom-cart__item" data-cart-line data-key="${escapeHtml(item.key)}">
          <a class="bottom-cart__image" href="${item.url}">${image}</a>
          <div class="bottom-cart__details">
            <a class="bottom-cart__title" href="${item.url}">${escapeHtml(item.product_title)}</a>
            ${variant}
            <div class="bottom-cart__price">${formatMoney(item.final_line_price ?? item.line_price, currency)}</div>
            <div class="bottom-cart__controls">
              <button type="button" aria-label="Decrease quantity" data-cart-qty="${minusQty}" data-key="${escapeHtml(item.key)}">−</button>
              <span>${item.quantity}</span>
              <button type="button" aria-label="Increase quantity" data-cart-qty="${item.quantity + 1}" data-key="${escapeHtml(item.key)}">+</button>
              <button class="bottom-cart__remove" type="button" data-cart-qty="0" data-key="${escapeHtml(item.key)}">Remove</button>
            </div>
          </div>
        </div>`;
    }).join('');
  };

  const escapeHtml = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const refreshCart = async () => {
    const response = await fetch(`${cartRoot}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form.product-form, form.quick-add-form');
    if (!form) return;
    event.preventDefault();

    const submit = form.querySelector('button[type="submit"]');
    const originalText = submit ? submit.textContent : '';
    if (submit) {
      submit.disabled = true;
      submit.textContent = 'Adding…';
    }

    try {
      const response = await fetch(`${cartRoot}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Could not add this item to cart.');
      }
      await refreshCart();
      setCartOpen(true);
      showStatus('Added to cart');
    } catch (error) {
      showStatus(error.message || 'Could not add to cart');
    } finally {
      if (submit) {
        submit.disabled = false;
        submit.textContent = originalText || 'Add to cart';
      }
    }
  });


  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mpaisa-checkout]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;

    const originalText = button.textContent;
    const allMpaisaButtons = document.querySelectorAll('[data-mpaisa-checkout]');
    allMpaisaButtons.forEach((el) => { el.disabled = true; });
    button.textContent = 'Opening checkout…';

    try {
      const cartResponse = await fetch(`${cartRoot}cart.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!cartResponse.ok) throw new Error('Unable to load your cart.');
      const cart = await cartResponse.json();
      if (!cart.item_count) throw new Error('Your cart is empty.');

      const updateResponse = await fetch(`${cartRoot}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Preferred payment method': 'M-PAiSA'
          }
        })
      });
      if (!updateResponse.ok) throw new Error('Unable to prepare M-PAiSA checkout.');

      window.location.assign(`${cartRoot}checkout`);
    } catch (error) {
      showStatus(error.message || 'Unable to open checkout');
      allMpaisaButtons.forEach((el) => { el.disabled = false; });
      button.textContent = originalText;
    }
  });

  document.addEventListener('click', async (event) => {
    const qtyButton = event.target.closest('[data-cart-qty]');
    if (!qtyButton) return;
    event.preventDefault();
    const key = qtyButton.dataset.key;
    const quantity = Number(qtyButton.dataset.cartQty);
    if (!key || Number.isNaN(quantity)) return;
    qtyButton.disabled = true;
    try {
      const response = await fetch(`${cartRoot}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Could not update cart.');
      }
      const cart = await response.json();
      renderCart(cart);
      if (quantity === 0) showStatus('Removed from cart');
    } catch (error) {
      showStatus(error.message || 'Could not update cart');
      qtyButton.disabled = false;
    }
  });
});
